import { Button } from '@mantine/core';
import { FC, useState } from 'react';

import DisplayForms from '@/components/PatientModal/DisplayForms.tsx';

import { usePatientAppointmentForms } from '@/hooks/usePatientAppointmentForms.ts';

import { DailyAppointment } from '@/models/appointment/Appointment.ts';
import { InsuranceType } from '@/models/insurance.ts';

import Paragraph from '../text/Paragraph.tsx';
import EditSelectedForms from './EditSelectedForms.tsx';

interface Props {
    appointment: DailyAppointment;
    isEditingFormsCallback: (arg0: boolean) => void;
    disabled: boolean;
    /** Fetch the required documents for this insurance type instead of the appointment's stored one. */
    insuranceType?: InsuranceType;
}

const PatientAppointmentForms: FC<Props> = ({ appointment, isEditingFormsCallback, disabled, insuranceType }) => {
    const [edit_documents, setEditDocuments] = useState(false);
    const {
        professional_form_templates,
        formatted_forms_for_appointment,
        is_loading_forms,
        form_data_code,
        mutateAppointmentForms,
    } = usePatientAppointmentForms(appointment, { insuranceType: insuranceType });

    const handleEditDocuments = (new_edit_documents: boolean): void => {
        setEditDocuments(new_edit_documents);
        isEditingFormsCallback(new_edit_documents);
    };

    const handleOnSaveForms = async (): Promise<void> => {
        await mutateAppointmentForms();
        handleEditDocuments(false);
    };

    return (
        <div className="flex flex-col gap-4">
            <div className="flex-start mt-1 w-full">
                <Paragraph className="text-sm uppercase text-slate-500">Dokumente</Paragraph>
            </div>
            <div className="flex w-full justify-between gap-2 overflow-x-hidden">
                {edit_documents && professional_form_templates && formatted_forms_for_appointment ? (
                    <EditSelectedForms
                        appointment={appointment}
                        professional_form_templates={professional_form_templates}
                        formatted_forms_for_appointment={formatted_forms_for_appointment}
                        onSave={handleOnSaveForms}
                        onCancel={() => handleEditDocuments(false)}
                        form_data_code={form_data_code}
                    />
                ) : (
                    <div className="flex w-full flex-col overflow-x-hidden">
                        <DisplayForms
                            is_loading={is_loading_forms}
                            formatted_forms_for_appointment={formatted_forms_for_appointment}
                            professional_form_templates={professional_form_templates}
                        />
                        {!is_loading_forms && (
                            <div className="w-full text-right">
                                <Button
                                    disabled={disabled}
                                    variant="transparent"
                                    className="capitalize underline disabled:bg-transparent disabled:text-slate-400"
                                    onClick={() => handleEditDocuments(!edit_documents)}
                                >
                                    Bearbeiten
                                </Button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PatientAppointmentForms;
